import { IUserSettingsState, IUserSettingsAction } from '../userSettings';

export const SET_FILTERS = 'opus/user/filter/SET_FILTERS';

export default function reducer(
  state: IUserSettingsState,
  action: IUserSettingsAction
): IUserSettingsState {
  switch (action.type) {
    case SET_FILTERS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
